'use client'
import {
  Responsive_default
} from "./chunk-4F2BFOUJ.mjs";
import {
  ImageWithPlaceholder_default
} from "./chunk-VPIMEK75.mjs";
import {
  Carousel
} from "./chunk-DLOFWUHV.mjs";
import {
  Button_default
} from "./chunk-ZVR4LKK3.mjs";

// src/Gallery/Gallery.tsx
import { ChevronIcon } from "@wbk/svg";
import { jsx, jsxs } from "react/jsx-runtime";
var Gallery = ({ slides, render, thumbs = true, startIndex }) => {
  const hasThumbs = thumbs && slides.length > 1;
  return /* @__PURE__ */ jsx(
    Responsive_default,
    {
      fullscreen: true,
      type: "modal",
      title: /* @__PURE__ */ jsx("span", { className: "block h-3" }),
      className: "[&>div]:bg-body/60 rounded-none",
      bodyClassName: "p-0",
      render,
      action: false,
      cancel: false,
      body: () => {
        return /* @__PURE__ */ jsx("div", { className: "h-full", children: /* @__PURE__ */ jsx(
          Carousel,
          {
            rootClassName: hasThumbs ? "h-[calc(100%-160px)]" : "h-[calc(100%-80px)]",
            className: "h-full p-2",
            containerClassName: "gap-2 h-full",
            renderFooter: ({
              scrollNext,
              scrollPrev,
              scrollTo,
              prevBtnDisabled,
              nextBtnDisabled,
              selectedIndex
            }) => {
              return /* @__PURE__ */ jsxs(
                "div",
                {
                  className: "bg-body-light p-S h-20 shrink-0 data-[thumbs=true]:h-40",
                  "data-thumbs": hasThumbs,
                  children: [
                    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-2", children: [
                      /* @__PURE__ */ jsx(
                        Button_default,
                        {
                          shape: "outlined",
                          theme: "white",
                          className: "flex h-10 w-10 items-center justify-center rounded-full border p-0 data-[hide=true]:hidden",
                          onClick: scrollPrev,
                          disabled: prevBtnDisabled,
                          "data-hide": prevBtnDisabled && nextBtnDisabled,
                          "aria-label": "Previous",
                          children: /* @__PURE__ */ jsx(ChevronIcon, { className: "h-4 w-4 ltr:rotate-180" })
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        Button_default,
                        {
                          shape: "outlined",
                          theme: "white",
                          className: "flex h-10 w-10 items-center justify-center rounded-full border p-0 data-[hide=true]:hidden",
                          onClick: scrollNext,
                          disabled: nextBtnDisabled,
                          "data-hide": prevBtnDisabled && nextBtnDisabled,
                          "aria-label": "Next",
                          children: /* @__PURE__ */ jsx(ChevronIcon, { className: "h-4 w-4 rtl:rotate-180" })
                        }
                      )
                    ] }),
                    hasThumbs && /* @__PURE__ */ jsx(
                      Carousel,
                      {
                        rootClassName: "container px-0 pt-2",
                        className: "py-2",
                        options: { dragFree: true, align: "center" },
                        children: slides.map((image, i) => {
                          const selected = slides[selectedIndex];
                          const isActive = selected.src === image.src;
                          return /* @__PURE__ */ jsx(
                            Button_default,
                            {
                              theme: "white",
                              shape: "text",
                              className: "h-16 w-16 shrink-0 p-0 ltr:mr-2 rtl:ml-2",
                              onClick: () => scrollTo(i),
                              children: /* @__PURE__ */ jsx(
                                ImageWithPlaceholder_default,
                                {
                                  className: "rounded-S h-full w-full object-cover opacity-40 data-[active=true]:opacity-100",
                                  src: image.src,
                                  alt: image.title || "",
                                  "data-active": isActive,
                                  loading: "lazy"
                                }
                              )
                            },
                            i
                          );
                        })
                      }
                    )
                  ]
                }
              );
            },
            options: { loop: true, startIndex },
            children: slides.map((image, i) => /* @__PURE__ */ jsx(
              ImageWithPlaceholder_default,
              {
                className: "shrink-0 basis-full object-contain",
                src: image.src,
                alt: image.title || "",
                loading: "lazy"
              },
              i
            ))
          }
        ) });
      }
    }
  );
};
var Gallery_default = Gallery;

export {
  Gallery_default
};
//# sourceMappingURL=chunk-2IRMN5VS.mjs.map